import { Subscription } from '../../types'

export function subscriptionFixture({
  accountIdentifier = '1234567890',
  freeMonths = 0
} = {}): Subscription {
  return {
    accountIdentifier,
    freeMonths
  }
}
